<div *appRole="['Movimientos.Crear']">
    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>
    <h1 mat-dialog-title>
       Crear imputación a propietario
    </h1>
    <div mat-dialog-content cdkTrapFocus>

        <div class="position-relative">
            <ngx-spinner [zIndex]="100" name="spMovimiento" bdColor="rgba(255,255,255,0.8)" size="default"
                color="#009688" type="ball-atom" [fullScreen]="false">
            </ngx-spinner>
            <form [formGroup]="movimientoForm">

                <!-- SECCIÓN CONTRATO -->
                <mat-card class="mb-3">
                    <mat-card-header>
                        <mat-card-title>
                            Información del Contrato
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="row" *ngIf="!contratoDetailDto">
                            <div class="col-12 col-md-6 mb-3">
                                <app-buscar-persona-propietaria (eventEntity)="selectPropietario($event)"
                                    [showDocumento]="false">
                                </app-buscar-persona-propietaria>
                            </div>
                            <div class="col-12 col-md-6">
                                <ngx-spinner [zIndex]="100" name="spAllContratosPropietario"
                                    bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom"
                                    [fullScreen]="false">
                                </ngx-spinner>
                                <mat-selection-list #contrato [multiple]="false" formControlName="Contrato">
                                    <mat-list-option *ngFor="let contrato of contratosPropietario" [value]="contrato">
                                        <p matListItemLine>
                                            <mat-icon>gavel</mat-icon> {{contrato.numeroContrato}} -
                                            <mat-icon>roofing</mat-icon> {{contrato.propiedad.descripcion}}
                                        </p>
                                    </mat-list-option>
                                </mat-selection-list>
                            </div>
                        </div>
                        <div class="row" *ngIf="contratoDetailDto">
                            <div class="col-12 col-md-6">
                                <p><mat-icon class="align-middle">roofing</mat-icon> <strong>Propiedad:</strong>
                                    {{(isFalsy(contratoDetailDto.propiedad.ubicacion) ? '' :
                                    contratoDetailDto.propiedad.ubicacion) +
                                    (isFalsy(contratoDetailDto.propiedad.piso) ? '' : ' ' +
                                    contratoDetailDto.propiedad.piso) +
                                    (isFalsy(contratoDetailDto.propiedad.departamento) ? '' : ' ' +
                                    contratoDetailDto.propiedad.departamento)}}
                                </p>
                            </div>
                            <div class="col-12 col-md-6">
                                <p><mat-icon class="align-middle">person</mat-icon> <strong>Propietario titular:</strong>
                                    <span *ngFor="let propietario of contratoDetailDto.propietarios">
                                        {{propietario.titular == true ? propietario.persona.descripcion : ""}}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

                <!-- SECCIÓN DATOS DEL MOVIMIENTO -->
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>
                            Datos del Movimiento
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-3">
                                <mat-form-field class="w-100">
                                    <ngx-spinner [zIndex]="100" name="spBusquedaTiposMovimiento"
                                        bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                                        [fullScreen]="false"></ngx-spinner>
                                    <mat-icon matPrefix>category</mat-icon>
                                    <mat-label>Tipo Movimiento</mat-label>
                                    <mat-select placeholder="Seleccione opción" formControlName="TipoMovimiento"
                                        [ngClass]="{'is-invalid':f.TipoMovimiento.touched && f.TipoMovimiento.errors}">
                                        <mat-option [value]="tipoMovimiento.id"
                                            *ngFor="let tipoMovimiento of lstTiposMovimiento;let i=index;trackBy:trackByItems">
                                            {{tipoMovimiento.resta == true ? tipoMovimiento.descripcion + ' (-)' :
                                            tipoMovimiento.descripcion + ' (+)'}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="f.TipoMovimiento.errors?.required && f.TipoMovimiento.touched">
                                        Este campo es <strong>requerido</strong>.
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-12 col-md-6 col-lg-3">
                                <mat-form-field class="w-100">
                                    <mat-icon matPrefix>event</mat-icon>
                                    <mat-label>Fecha Emisión</mat-label>
                                    <input matInput [matDatepicker]="picker" formControlName="FechaEmision">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                    <mat-error *ngIf="f.FechaEmision.errors?.required">
                                        Este campo es <strong>requerido</strong>.
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-12 col-md-6 col-lg-3">
                                <mat-form-field class="w-100">
                                    <mat-icon matPrefix>attach_money</mat-icon>
                                    <mat-label>Importe</mat-label>
                                    <input type="text" mask="separator.2" thousandSeparator="," placeholder="0.00"
                                        formControlName="Importe" matInput>
                                    <mat-error *ngIf="f.Importe.errors?.required">
                                        Este campo es <strong>requerido</strong>.
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-12 col-md-6 col-lg-3 d-flex align-items-center">
                                <mat-checkbox formControlName="Comisionable">
                                    <mat-icon class="align-middle">percent</mat-icon> Aplicar Comisión
                                </mat-checkbox>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <mat-form-field class="w-100">
                                    <mat-icon matPrefix>description</mat-icon>
                                    <mat-label>Descripción</mat-label>
                                    <textarea matInput #message rows="3" formControlName="Descripcion"></textarea>
                                    <mat-error *ngIf="f.Descripcion.errors?.maxlength">
                                        Superó el máximo de caracteres.
                                    </mat-error>
                                    <mat-hint align="start"><strong>Amplíe información</strong></mat-hint>
                                    <mat-hint align="end">{{message.value.length}} / 2000</mat-hint>
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

            </form>
        </div>

    </div>
    <div mat-dialog-actions align="end">
        <button mat-button mat-dialog-close color="warn" (click)="closeDialog()">
            <mat-icon>cancel</mat-icon> Cancelar
        </button>
        <button mat-raised-button color="primary" *appRole="['Movimientos.Crear']"
            [disabled]="!movimientoForm.valid" (click)="onSubmit()">
            <mat-icon>save</mat-icon> Agregar
        </button>
    </div>
</div>
